// The Dashboard's top-right chrome (Brief 4 polish) — a slim sticky strip that
// rides the top of the content pane and holds the two icon-only controls:
// Appearance (light/dark/contrast) and Account (identity + log out). Icons only,
// each opening its own dropdown/popout. The strip itself is click-through (only
// the buttons take pointer events) so it never steals clicks from the content
// scrolling beneath it. Token-pure (var(--waytide-sys-*)).

import { ThemeCycle } from "../theme/ThemeCycle";
import { AppearanceMenu } from "../theme/AppearanceMenu";
import { AccountMenu } from "../account/AccountMenu";
import "./topbar.css";

export function TopBar() {
  return (
    <div className="wt-topbar" data-testid="dash-topbar">
      {/* The washed theme family (40) — the same control as the landing. The
          AppearanceMenu beside it keeps the a11y axis (system / light / dark /
          high-contrast). Both persist to the one wt_appearance cookie. */}
      <ThemeCycle />
      <AppearanceMenu />
      <AccountMenu />
    </div>
  );
}
